import React from 'react';
import classnames from 'classnames';
import LocatorResultDetails from './LocatorResultDetails';
import url from 'url';

const LocatorResults = ({
  currentPlace,
  getDetails,
  hasLoadMore,
  loadMore,
  places,
  setCurrentPlace
}) => {
  if (places.length === 0) {
    return null;
  }
  return (
    <ul className="map__results">
      {places.map((place) => {
        const websiteUrl = place.details.website
          ? url.parse(place.details.website)
          : null;

        return (
          <li
            key={place.id}
            className={classnames('map__result', {
              'map__result--current': place.id === currentPlace
            })}
          >
            <LocatorResultDetails place={place} />
            <ul className="map__result-actions">
              <li>
                <a
                  className="link link--green"
                  href="#"
                  onClick={(event) => {
                    event.preventDefault();
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      event: 'Retailer Link Click',
                      retailerName: place.details.name
                    });
                    setCurrentPlace(place.id);
                  }}
                >
                  View on Map
                </a>
                {websiteUrl && websiteUrl.hostname && (
                  <>
                    <span className="u--display-inline-block u--padding-left-10 u--padding-right-10 u--color-blue">
                      |
                    </span>

                    <a href={websiteUrl.href} target="_blank" rel="noopener">
                      View Website
                    </a>
                  </>
                )}
              </li>
              {!place.hasDetails && (
                <li>
                  <a
                    className="link link--red"
                    href="#"
                    onClick={(event) => {
                      event.preventDefault();
                      getDetails(place.id);
                    }}
                  >
                    View Contact Info
                  </a>
                </li>
              )}
            </ul>
          </li>
        );
      })}
      {hasLoadMore && (
        <li className="map__result">
          <button
            type="button"
            className="btn btn--block btn--red"
            onClick={() => loadMore()}
          >
            <span className="btn__content">
              <span className="btn__text">Load more</span>
            </span>
          </button>
        </li>
      )}
    </ul>
  );
};

export default LocatorResults;
